import { Register } from 'components/User';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {getAvailableCompanies, userRegistration } from 'actions/broker';
import { getStateList } from 'actions/appraiser';
import { validateUserRegistration } from 'validations';
import responseHandler from 'responseHandler';

const mapStateToProps = (state) => {
    return {
        stateList: state.appraiser.stateList,
        fetchingStateList: state.appraiser.fetchingStateList,
        isSubmitting: state.brokerRegistration.isSubmitting,
        submitSuccess: state.brokerRegistration.success,
        username: state.brokerRegistration.username,
        availableCompanies: state.brokerRegistration.availableCompanies,
        isFetchingCompanies: state.brokerRegistration.isFetchingCompanies,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getStateList() {
        dispatch(getStateList());
    },
    userRegistration(user) {
        dispatch(userRegistration(user));
    },
    makeToast(text, type) {
        responseHandler.customToast(text, type, dispatch);
    },
    getAvailableCompanies() {
        dispatch(getAvailableCompanies());
      },
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'Register',
    validate: validateUserRegistration
})(Register));
